$(function() {

	$('#MobileNavTrigger').on('click', function() {
		$('.nav-submenu-wrapper').hide();
	});

	$('.has-submenu').on('click', function(e) {
		e.preventDefault();

		var $this = $(this);
		var mainNav = $('#MobileNav');
		var submenu = $('.nav-submenu-wrapper');
		console.log( $this.data('submenu') );

		$.each(submenu, function(i, e) {
			var $sub = $(this);
			// console.log( $sub.attr('id') );

			if ( $this.data('submenu') == $sub.attr('id') ) {
				mainNav.fadeOut('fast');
				$sub.fadeIn('fast');
			}

		});
		
	});

	$('.nav-back').on('click', function(e) {
		e.preventDefault();

		var $this = $(this);
		var container = '#'+$this.data('parent');
		var previous = '#'+$this.data('target');

		$(container).fadeOut('fast')
		$(previous).fadeIn('fast');

	});

	$('#warrantyClaimForm').validate();

});
